(() => {
  const root = document.querySelector('[data-geolocation-popup]');
  if (!root) return;

  const storageKey = root.dataset.geolocationPopupKey || 'geolocation-popup-accepted';
  const dialog = root.querySelector('.geolocation-popup__dialog');
  const form = root.querySelector('form');
  let lastFocusedElement = null;

  const isAccepted = () => {
    try { return window.localStorage.getItem(storageKey) === 'true'; } catch (error) { return false; }
  };

  const rememberAcceptance = () => {
    try { window.localStorage.setItem(storageKey, 'true'); } catch (error) { /* Storage may be blocked. */ }
  };

  const open = () => {
    lastFocusedElement = document.activeElement;
    root.hidden = false;
    window.requestAnimationFrame(() => dialog?.focus());
  };

  const close = () => {
    root.hidden = true;
    if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
  };

  root.querySelectorAll('[data-geolocation-close]').forEach((element) => {
    element.addEventListener('click', close);
  });

  form?.addEventListener('submit', () => rememberAcceptance());

  document.addEventListener('keydown', (event) => {
    if (!root.hidden && event.key === 'Escape') close();
  });

  if (!isAccepted()) open();
})();
